let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("3JpCe"), load("rpGya")]).then(() => parcelRequire('eaE9P'));